import { createPublicClient, http, type PublicClient } from 'viem'
import { mainnet, sepolia, arbitrum, base } from 'viem/chains'
import { fetchEnv } from './fetchEnv'
import { Chain } from '../interfaces/common'

export const getEthProvider = (chain: Chain): PublicClient => {
  const isMainnet = fetchEnv('ETH_CHAIN') !== 'sepolia'
  const infuraSecret = fetchEnv('INFURA_SECRET')
  let apiAdress, viemChain

  switch (chain) {
    case Chain.ARB:
      apiAdress = 'arbitrum-mainnet'
      viemChain = arbitrum
      break
    case Chain.BASE:
      apiAdress = 'base-mainnet'
      viemChain = base
      break
    default:
      apiAdress = isMainnet ? 'mainnet' : 'sepolia'
      viemChain = isMainnet ? mainnet : sepolia
  }

  return createPublicClient({
    chain: viemChain,
    transport: http(`https://${apiAdress}.infura.io/v3/${infuraSecret}`),
  }) as unknown as PublicClient
}
